import React, { useMemo } from 'react';
import { ResetProgressIcon } from '../shared/ToolbarPrimitives';
import { ToolbarBtn } from './FlowToolbar/ToolbarButton';

/**
 * Reset-campaign button. Parent must wrap with ResponsiveToolbar.Item
 * directly — the overflow menu clones Item.props.children.
 */
const ResetCampaignToolbarItem = ({ onResetCampaignProgress }) => {
  const iconEl = useMemo(() => <ResetProgressIcon />, []);
  return (
    <ToolbarBtn
      icon={iconEl}
      label="Reset campaign"
      onClick={onResetCampaignProgress}
      title="Clear every decision answer, set all missions to To Do, uncheck boxes in attached docs, and clear upload fields. Nested campaigns under this tree are included. Archived items are unchanged."
    />
  );
};

export default ResetCampaignToolbarItem;
